import { ServiceAvailableDateMapper } from './ServiceAvailableDate/ServiceAvailableDateMapper.js';
import { PriceDetailMapper } from '../../models/Price/PriceDetailMapper.js';
import { ServiceTimeLeftForFirstAvailableDateMapper } from './ServiceTimeLeftForFirstAvailableDate/ServiceTimeLeftForFirstAvailableDateMapper.js';
import { ServiceUpsalesMapper } from './ServiceUpsales/ServiceUpsalesMapper.js';
import { PriceProductsMapper } from '../../models/Price/PriceProductsMapper.js';

class ServiceMapper {
  static createFromResponse(response) {
    var _response$price$items, _response$print_in_st, _response$max_dimensi, _response$url_forbidd, _response$url_terms_a;
    return {
      availableDates: ServiceAvailableDateMapper.getSortedAvailableDates(response.available_dates),
      carrierName: response.carrier_name,
      category: response.category,
      carrierProductId: response.carrier_product_id,
      currency: response.currency,
      dropOff: {
        destination: response.delivery_to_parcelshop,
        origin: response.dropoff
      },
      firstEstimatedDeliveryDate: response.first_estimated_delivery_date,
      customsRequired: {
        available: response.customs_required
      },
      hasPaperlessCustoms: response.has_paperless_customs,
      hasPrintInStore: response.has_print_in_store,
      id: response.id,
      name: response.name,
      price: PriceDetailMapper.createModelFromResponse(response.price),
      products: this.createServiceProductsFromResponse((_response$price$items = response.price.items) !== null && _response$price$items !== void 0 ? _response$price$items : []),
      printInStoreUrl: (_response$print_in_st = response.print_in_store_url) !== null && _response$print_in_st !== void 0 ? _response$print_in_st : undefined,
      isOwnContract: response.is_own_contract,
      logoId: response.logo_id,
      maxDimensionsMessage: (_response$max_dimensi = response.max_dimensions_message) !== null && _response$max_dimensi !== void 0 ? _response$max_dimensi : undefined,
      serviceInfo: response.service_info,
      tags: response.tags,
      timeLeftForFirstAvailableDate: ServiceTimeLeftForFirstAvailableDateMapper.createFromResponse(response.time_left_first_available_date),
      transitHours: parseInt(response.transit_hours, 10),
      upsales: ServiceUpsalesMapper.createFromResponse(response),
      urlForbiddenItems: (_response$url_forbidd = response.url_forbidden_items) !== null && _response$url_forbidd !== void 0 ? _response$url_forbidd : undefined,
      urlTermsAndConditions: (_response$url_terms_a = response.url_terms_and_conditions) !== null && _response$url_terms_a !== void 0 ? _response$url_terms_a : undefined,
      printInStoreDefault: response.print_in_store_default
    };
  }
  static createFromComOrderSummaryServiceResponse(response) {
    return {
      carrierName: response.carrier,
      dropOff: {
        destination: response.is_drop_off_in_destination,
        origin: response.is_drop_off_in_origin
      },
      id: Number(response.id),
      name: response.name,
      hasPaperlessCustoms: response.has_paperless_customs
    };
  }
  static createServiceProductsFromResponse(items) {
    const products = items.reduce((products, item) => {
      switch (item.concept.toUpperCase()) {
        case 'PORTERAGE':
          products.porterage = item;
          break;
        case 'ADDITIONAL_HANDLING':
          products.additional_handling = item;
          break;
        case 'MANAGEMENT_FEE':
          products.management_fee = item;
          break;
      }
      return products;
    }, {});
    return PriceProductsMapper.createModelFromResponse(products);
  }
}

export { ServiceMapper };
//# sourceMappingURL=ServiceMapper.js.map
